import moment from "moment";
export function utcDateToLocal(myDate) {
    var utc_date = moment.utc(moment(myDate)).format('YYYY-MM-DDTHH:MM:SSZ');
    utc_date = moment(utc_date).toDate();
    myDate = moment(utc_date).local().format('YYYY-MM-DD');
    return myDate
}